import React from "react";

export default function Spinner(props) {
  var size = props.size || 44;
  var color = props.color || "#c9963a";
  return React.createElement("div", { style: { width: size, height: size, borderRadius: "50%", border: "2px solid #e4d9c8", borderTopColor: color, animation: "spin .85s linear infinite", margin: "0 auto" } });
}
